
import React, { createContext, useContext, ReactNode } from 'react';
import { useMilestoneCelebration, Milestone } from '@/hooks/useMilestoneCelebration';
import { MilestoneCelebrationDialog } from '@/components/celebrations/MilestoneCelebrationDialog';

interface MilestoneCelebrationContextType {
  triggerPostMatchCheck: () => Promise<void>;
  checkMilestones: (
    totalMatches: number,
    currentStreak: number,
    streakType: 'win' | 'loss' | undefined,
    skillRating: number
  ) => Promise<void>;
}

const MilestoneCelebrationContext = createContext<MilestoneCelebrationContextType | null>(null);

export const useMilestoneCelebrationContext = () => {
  const context = useContext(MilestoneCelebrationContext);
  if (!context) {
    throw new Error('useMilestoneCelebrationContext must be used within MilestoneCelebrationProvider');
  }
  return context;
};

interface MilestoneCelebrationProviderProps {
  children: ReactNode;
}

export const MilestoneCelebrationProvider: React.FC<MilestoneCelebrationProviderProps> = ({ children }) => {
  const {
    showCelebration,
    currentMilestone,
    closeCelebration,
    checkMilestones,
    triggerPostMatchCheck,
  } = useMilestoneCelebration();

  return (
    <MilestoneCelebrationContext.Provider value={{ triggerPostMatchCheck, checkMilestones }}>
      {children}
      <MilestoneCelebrationDialog
        open={showCelebration}
        onClose={closeCelebration}
        milestone={currentMilestone}
      />
    </MilestoneCelebrationContext.Provider>
  );
};
